module.exports = __webpack_public_path__ + "02_long_gold.ab523eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_long_gold.png
// module id = hNxT
// module chunks = 0